// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"VTNGR","rc-tabs-tab":"_27G13","rc-tabs-tab-active":"_0hqNY","tip":"YV1pq","tip-label":"PP3SR","tip-group":"-7-XA","select-container":"y9Wcz","select":"suctj"};